import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultSeatPickerSeatAppearanceConfig = {
    iconName: 'normal-seat',
    showLabels: false,
    labelOffsetX: 0,
    labelOffsetY: 0
};
export const seatPickerSeatAppearanceConfigValidator = Validator.object({
    iconName: nonEmptyStringValidator,
    showLabels: Validator.optional(Validator.boolean()),
    labelOffsetX: Validator.optional(Validator.number()),
    labelOffsetY: Validator.optional(Validator.number())
});
